export default __webpack_public_path__ + "images/prepaid-credits-banner.png";